import { useGetUser, useUpdateUser } from '../../hooks/api-hooks';
import React, { useState } from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { queryClient } from '../../app';

export default function Account () {
  const user = useGetUser()
  const userMutation = useUpdateUser()
  const [usernameError, setUsernameError] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  /**
   * Handle updating user information
   * @param e
   */
  const handleUpdateUser = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const userName = formData.get('username') as string;

    if (userName.length < 2) {
      setUsernameError('Username must be at least 2 characters long');
      return;
    }

    if (userName === user.data?.userName) {
      return; // Username is the same, no need to save
    }

    setIsSaving(true);
    try {
      const response = await userMutation.mutateAsync({ updateUserBody: { userName } });
      if(user.data){
        queryClient.setQueryData(['getUser'], {...user.data, userName: response.userName});
      }
      setUsernameError('')
    } catch (error) {
      console.error('Error updating user:', error);
    } finally {
      setIsSaving(false);
    }
  };


  return (
    <div className="divide-y divide-gray-200">
      <div className='grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 py-16 md:grid-cols-3 lg:px-8'>
        <div>
          <h2 className='text-base font-semibold leading-7 text-gray-900'>Personal Information</h2>
        </div>

        <form className='md:col-span-2' onSubmit={handleUpdateUser}>
          <div className='grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6'>
            <div className='col-span-full'>
              <label htmlFor='email' className='block text-sm font-medium leading-6 text-gray-900'>
                Email address
              </label>
              <div className='mt-2'>
                <input
                  id='email'
                  name='email'
                  type='email'
                  autoComplete='email'
                  disabled
                  value={user.data?.email}
                  className='block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200 sm:text-sm sm:leading-6'
                  readOnly
                />
              </div>
            </div>

            <div className='col-span-full'>
              <label htmlFor='username' className='block text-sm font-medium leading-6 text-gray-900'>
                Username
              </label>
              <div className={`relative mt-2 rounded-md shadow-sm ${usernameError ? 'pr-10' : ''}`}>
                <input
                  type='text'
                  name='username'
                  id='username'
                  className={`block w-full rounded-md border-0 py-1.5 ${
                    usernameError
                      ? 'text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-inset focus:ring-red-500'
                      : 'text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600'
                  } sm:text-sm sm:leading-6`}
                  placeholder='Add a username'
                  defaultValue={user.data?.userName}
                />
                {usernameError && (
                  <div className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3'>
                    <ExclamationCircleIcon className='h-5 w-5 text-red-500' aria-hidden='true' />
                  </div>
                )}
              </div>
              {usernameError && (
                <p className='mt-2 text-sm text-red-600' id='username-error'>
                  {usernameError}
                </p>
              )}
            </div>
          </div>

          <div className='mt-8 flex'>
            <button
              type='submit'
              className={`rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
                isSaving ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              disabled={isSaving}            >
              {isSaving ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Saving...
                </>
              ) : (
                'Save'
              )}
            </button>
          </div>
        </form>
      </div>

      {/* Update PW */}
      {/*<div className='grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 py-16 md:grid-cols-3 lg:px-8'>*/}
      {/*  <div>*/}
      {/*    <h2 className='text-base font-semibold leading-7 text-gray-900'>Change password</h2>*/}
      {/*    <p className='mt-1 text-sm leading-6 text-gray-600'>*/}
      {/*      Update your password associated with your account.*/}
      {/*    </p>*/}
      {/*  </div>*/}

      {/*  <form className='md:col-span-2'>*/}
      {/*    <div className='grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6'>*/}
      {/*      <div className='col-span-full'>*/}
      {/*        <label htmlFor='current-password' className='block text-sm font-medium leading-6 text-gray-900'>*/}
      {/*          Current password*/}
      {/*        </label>*/}
      {/*        <div className='mt-2'>*/}
      {/*          <input*/}
      {/*            id='current-password'*/}
      {/*            name='current_password'*/}
      {/*            type='password'*/}
      {/*            autoComplete='current-password'*/}
      {/*            className='block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*      </div>*/}

      {/*      <div className='col-span-full'>*/}
      {/*        <label htmlFor='new-password' className='block text-sm font-medium leading-6 text-gray-900'>*/}
      {/*          New password*/}
      {/*        </label>*/}
      {/*        <div className='mt-2'>*/}
      {/*          <input*/}
      {/*            id='new-password'*/}
      {/*            name='new_password'*/}
      {/*            type='password'*/}
      {/*            autoComplete='new-password'*/}
      {/*            className='block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*      </div>*/}

      {/*      <div className="col-span-full">*/}
      {/*        <label htmlFor="confirm-password" className="block text-sm font-medium leading-6 text-gray-900">*/}
      {/*          Confirm password*/}
      {/*        </label>*/}
      {/*        <div className="mt-2">*/}
      {/*          <input*/}
      {/*            id="confirm-password"*/}
      {/*            name="confirm_password"*/}
      {/*            type="password"*/}
      {/*            autoComplete="new-password"*/}
      {/*            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}

      {/*    <div className="mt-8 flex">*/}
      {/*      <button*/}
      {/*        type="submit"*/}
      {/*        className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"*/}
      {/*      >*/}
      {/*        Save*/}
      {/*      </button>*/}
      {/*    </div>*/}
      {/*  </form>*/}
      {/*</div>*/}
    </div>
  )
}